import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_buttonView/_layout/training/_app')({
  staticData: {
    title: 'Training',
  },
});
